import { apiGet } from '@/store/api';

export interface GridFieldConfig {
  FIELDNAME: string;
  SORT_ORDER: number;
  VISIBLE: number;
}

/**
 * Fetches grid field configuration (column order and visibility) from ccm_field table.
 * @param type 0 = people grid, 1 = tasks grid
 */
export async function getCrewChangeGridFields(type: number): Promise<GridFieldConfig[]> {
  const result = await apiGet(`crewchange/gridFields/${type}`);
  return result;
}
